import newTicketSound from '../assets/newticket.mp3';
import newMessageSound from '../assets/newmessage.mp3';

class AtendimentoNotificationSoundService {
  private newTicketAudio: HTMLAudioElement | null = null;
  private newMessageAudio: HTMLAudioElement | null = null;
  private audioUnlocked = false;

  constructor() {
    this.init();
    this.setupUnlockListeners();
  }

  private init() {
    this.newTicketAudio = new Audio(newTicketSound);
    this.newTicketAudio.preload = 'auto';
    this.newMessageAudio = new Audio(newMessageSound);
    this.newMessageAudio.preload = 'auto';
  }

  private setupUnlockListeners() {
    const unlockAudio = () => {
      if (this.audioUnlocked) return;

      const tryUnlock = (audio: HTMLAudioElement | null) => {
        if (!audio) return;
        audio.volume = 0;
        audio.play()
          .then(() => {
            audio.pause();
            audio.currentTime = 0;
            audio.volume = 1;
            this.audioUnlocked = true;
          })
          .catch(() => undefined);
      };

      tryUnlock(this.newTicketAudio);
      tryUnlock(this.newMessageAudio);
    };

    document.addEventListener('click', unlockAudio);
    document.addEventListener('keydown', unlockAudio);
    document.addEventListener('touchstart', unlockAudio);
  }

  private play(audio: HTMLAudioElement | null) {
    if (!audio) return;

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.play().catch(() => undefined);
    } catch {
      // Navegador pode bloquear audio antes da primeira interacao.
    }
  }

  playNewTicketSound() {
    this.play(this.newTicketAudio);
  }

  playNewMessageSound() {
    this.play(this.newMessageAudio);
  }
}

export const atendimentoNotificationSoundService = new AtendimentoNotificationSoundService();
